import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SettingStore } from './setting.store';
import { SettingAction } from './setting.action';
import { DARK, LIGHT, Setting } from '@easy-lib/modules/settings';
import { BehaviorSubject, combineLatestWith, tap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import NoSleep from '@uriopass/nosleep.js';
import { UserDeviceService } from '@easy-lib/modules/shared/services';

@Injectable({
	providedIn: 'root'
})
export class SettingFacade {
	constructor(
		private store: Store,
		private settingStore: SettingStore,
		private userDeviceService: UserDeviceService
	) {
		this.noSleep = new NoSleep();
		toSignal(
			this.settingStore.setting$.pipe(
				combineLatestWith(this.userDeviceService.deviceType$),
				tap(([setting]) => {
					this.changeTheme(setting.lightTheme);
					this.changeNumberStyle(setting.usePersianNumber);
					this.preventSleepIfSet(setting.noSleep);
				})
			)
		);
	}
	noSleep: any;

	private mainNavbarVisibilitySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	mainNavbarVisibility$ = this.mainNavbarVisibilitySubject.asObservable();

	loadSetting() {
		this.store.dispatch(SettingAction.load());
	}
	setSetting(setting: Setting) {
		this.store.dispatch(SettingAction.update({ setting }));
	}
	resetSetting() {
		this.store.dispatch(SettingAction.reset());
	}

	changeNumberStyle(usePersianNumber = false) {
		const className = 'ss02';
		if (usePersianNumber) {
			if (!document.body.classList.contains(className)) {
				document.body.classList.add(className);
			}
		} else {
			document.body.classList.remove(className);
		}
	}
	preventSleepIfSet(noSleep: boolean) {
		try {
			if (this.userDeviceService.isAndroid) {
				if (noSleep) {
					this.noSleep.enable(); // always keep the screen on!
				} else {
					this.noSleep.disable(); // let screen turn off on system standby mode
				}
			}
		} catch (error) {
			null;
		}
	}
	private switchStyle(theme) {
		if (theme === DARK) {
			document.documentElement.setAttribute('data-bs-theme', 'dark');
		}
		if (theme === LIGHT) {
			document.documentElement.setAttribute('data-bs-theme', 'light');
		}
	}

	changeTheme(isLight) {
		if (isLight) {
			this.switchStyle(LIGHT);
		} else {
			this.switchStyle(DARK);
		}
	}
}
